// import { Box, Button, Container, TextField, Typography } from '@mui/material'
// import React, { useState } from 'react'
// import { useDispatch } from 'react-redux'
// import { useNavigate } from 'react-router-dom'
// import { toast } from 'react-toastify'
// import { login as loginAction } from '../../features/authSlice'
// import { login } from '../../services/userService'
// import useStyles from './styles'

// const Login = () => {
//   const styles = useStyles()
//   const [username, setUsername] = useState('')
//   const [password, setPassword] = useState('')

//   const dispatch = useDispatch()

//   const navigate = useNavigate()

//   const loginUser = async () => {
//     if (username.length === 0) {
//       toast.warn('please enter user name first')
//     } else if (password.length === 0) {
//       toast.warn('please enter password first')
//     } else {
//       const response = await login(username, password)
//       if (response['status'] === 'success') {
//         toast.success('Welcome to the Orbo!!!')
//         const data = response['data']
//         sessionStorage.setItem('username', username)
//         sessionStorage.setItem('name', data['name'])
//         sessionStorage.setItem('token', data['token'])
//         sessionStorage.setItem('email', data['email'])
//         sessionStorage.setItem('reportType', data['reportType'])

//         // update redux
//         dispatch(loginAction(data))

//         navigate('/current-scans')
//       } else {
//         toast.error(response['error'])
//       }
//     }
//   }

//   return (
//     <Container maxWidth='xs'>
//       <Box
//         sx={{
//           marginTop: 8,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//         }}
//       >
//         <Typography component='h1' variant='h5'>
//           Sign in
//         </Typography>
//         <Box sx={{ mt: 1 }}>
//           <TextField
//             margin='normal'
//             fullWidth
//             label='User name'
//             autoFocus
//             onChange={(e) => {
//               setUsername(e.target.value)
//             }}
//           />
//           <TextField
//             margin='normal'
//             fullWidth
//             label='Password'
//             type='password'
//             onChange={(e) => {
//               setPassword(e.target.value)
//             }}
//           />
//           <Button
//             onClick={loginUser}
//             fullWidth
//             variant='contained'
//             sx={{ mt: 3, mb: 2 }}
//           >
//             Sign In
//           </Button>
//         </Box>
//       </Box>
//     </Container>
//   )
// }

// export default Login

import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import config from '../../config'
import { MyContext } from '../ContextApi'
import Swal from 'sweetalert2'
import { logoutUser, updateExe } from '../../services/transactions'


const ui_version = "1.3.3";


const Login = () => {


  const navigate = useNavigate()
  const [serverStatus, setServerStatus] = useState("checking"); // 'up', 'down', 'checking'
  const [serverPort, setServerPort] = useState(null); // To store the port number of the running server
  const [erpCode, setErpCode] = useState('')
  const [installationId, setInstallationId] = useState('')
  const [clientId, setClientId] = useState('')
  const [disabled, setDisabled] = useState(false)
  const { setEncryptedSessionItem, getDecryptedSessionItem } = useContext(MyContext)


 

useEffect(() => {
  const checkServer = async () => {
    const ports = [27279, 15559, 18889, 21999]; 
    for (const port of ports) {
      try {
        const res = await fetch(`${config.ip}:${port}/health`);
        if (res.ok) {
          const data = await res.json();
          if (data.status === "success") {
            setEncryptedSessionItem("server", `${config.ip}:${port}`);
            setServerPort(port);
            setServerStatus("up");
            return;
          }
        }
      } catch {}
    }
    setServerStatus("down");
  };

  checkServer();
  const interval = setInterval(checkServer, 2000);
  
  return () => clearInterval(interval);
}, []);


  const logout = async () => {
    await logoutUser({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
    });
    localStorage.clear();
  };


  const onLogin = () => {
    if (erpCode.length == 0) {
      toast.warn('please enter erp code')
    } else if (installationId.length == 0) {
      toast.warn('please enter installation id')
    } else if (clientId.length == 0) {
      toast.warn('please enter client id')
    } else {
      setDisabled(true)
      const url = `${getDecryptedSessionItem('server')}/user/login`

      axios
        .post(url, {
          erpCode,
          installationId,
          clientId,
          ui_version,
        })
        .then((response) => {
          const result = response.data;
          if (result['status'] === 'error') {
            toast.error('Please Enter Proper login Details')
          }

          const exe_url = result.data.exe_url
          const latest_exe_verion = result.data.latest_verion
          const userName = result.data.userName

          const handleLoginSuccess = () => {
            toast.success('Successfully logged in')
            localStorage.setItem('Token', result.data.token)

            setEncryptedSessionItem('reportType', erpCode.toLowerCase())
            setEncryptedSessionItem('clientId', clientId)
            setEncryptedSessionItem('installationId', installationId)
            setEncryptedSessionItem('userName', userName)

            navigate('/scan-qr')
            window.location.reload()
          }
          if (result['status'] === 'success' && result['exe_version'] === 'mismatched' && !latest_exe_verion) {
            handleLoginSuccess()
          }

          else if (result['status'] === 'success' && result['exe_version'] === 'mismatched') {
            Swal.fire({
              title: 'Do you want to update?',
              text: `Latest Exe Version is ${latest_exe_verion}`,
              icon: 'question',
              showCancelButton: true,
              confirmButtonText: 'Yes, update',
              cancelButtonText: 'No, cancel',
            }).then(async (result) => {
              if (result.isConfirmed) {
                const swalWithProcess = Swal.fire({
                  title: 'Updating...',
                  text: 'Please wait while we are Updating backend-exe file.',
                  icon: 'info',
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                });

                try {
                  logout()
                  const updateResponse = await updateExe(exe_url);
                  const data = updateResponse.data;

                  swalWithProcess.close();

                  if (data.status === "success") {
                    Swal.fire(
                      'Updated!',
                      'File has been updated successfully.',
                      'success'
                    );
                  } else {
                    Swal.fire(
                      'Update Failed',
                      'There was an issue with the update.',
                      'error'
                    );
                  }
                } catch (error) {
                  console.error("Error occurred during update:", error);
                  swalWithProcess.close();
                }

              } else if (result.dismiss === Swal.DismissReason.esc) {
                console.log("popup closed");
              }
              else {
                handleLoginSuccess();  // "Cancel"
              }

            });
          } else if (result['status'] === 'success') {
            handleLoginSuccess();
          } else {
            toast.error(result['error'])
          }
          setDisabled(false)
        })
        .catch((error) => {
          setDisabled(false)
          toast.error(error)
        })
    }
  }

  return (
    <>
      <div className="container" style={{ height: 'calc(100vh - 154px)', cursor: serverStatus !== "up" ? 'wait' : 'pointer' }} >

        <h3 className="title">Login</h3>

        <div className="mb-3">
          <label htmlFor="">ERP Code</label>
          <input
            onChange={(e) => setErpCode(e.target.value)}
            onBlur={() => setErpCode(erpCode.trim())}
            type="text"
            className="form-control"
            value={erpCode}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="">Installation Id</label>
          <input
            onChange={(e) => setInstallationId(e.target.value)}
            onBlur={() => setInstallationId(installationId.trim())}
            type="text"
            className="form-control"
            value={installationId}
          />
        </div>

        <div className="mb-3" style={{ cursor: serverStatus !== "up" ? 'wait' : 'pointer' }}>
          <label htmlFor="">Client Id</label>
          <input
            onChange={(e) => setClientId(e.target.value)}
            onBlur={() => setClientId(clientId.trim())}
            type="text"
            className="form-control"
            value={clientId}
          />
        </div>

        {serverStatus === "checking" && <p>Checking server status...</p>}
        {serverStatus === "up" && <p>✅ Exe is running on port {serverPort}</p>}
        {serverStatus === "down" && <p>⚠️ Exe is not running. please wait ...</p>}

        <div className="mb-3" style={{ marginTop: 30 }}>
          <button
            disabled={serverStatus !== "up" || disabled}
            onClick={onLogin}
            className="btn btn-success"
          >
            Login
          </button>
        </div>
      </div>

      <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
        V {ui_version}
      </p>
    </>
  )
}

export default Login;
